// 基本配置项

export default {
	/*
	 *  * 搜索QQ号    1
	 *  * 搜索微信号    3
	 *  * 8、14  群聊
	 *  * 10、13   来自通讯录好友
	 *  * 4、12    来自QQ好友
	 *  * 15     搜索手机号
	 *  * 17     通过名片分享添加
	 *  * 18     附近的人
	 *  * 22、23、24、26、28、29  摇一摇
	 *  * 25    漂流瓶
	 *  * 30    通过扫一扫添加
	 *  * 34    公众号 没有通过按钮
	 *  * 48    雷达
	 *  * 58、59、60 通过Google联系人添加
	 *  * 76   通过LinkedIn添加
	 */
	fansScene:{
		"1": '搜索QQ号',
		"3": '搜索微信号',
		"4": '来自QQ好友',
		"8": '群聊',
		"10": '来自通讯录好友',
		"12": '来自QQ好友',
		"13": '来自通讯录好友',
		"14": '群聊',
		"15": '搜索手机号',
		"17": '通过名片分享添加',
		"18": '附近的人',
		"22": '摇一摇',
		"23": '摇一摇',
		"24": '摇一摇',
		"25": '漂流瓶',
		"26": '摇一摇',
		"28": '摇一摇',
		"29": '摇一摇',
		"30": '通过扫一扫添加',
		"34": '公众号没有通过按钮',
		"48": '雷达',
		"58": '通过Google联系人添加',
		"59": '通过Google联系人添加',
		"60": '通过Google联系人添加',
		"76": '通过LinkedIn添加'
	}
}